import React from "react";
import PropTypes from "prop-types";
import formatCurrency from "src/lib/format-currency";
import convertPoundsToPence from "src/lib/convert-pounds-to-pence";

function Currency({ value = 0, valueInPounds = 0, ...props }) {
  const parsedValue = valueInPounds
    ? convertPoundsToPence(valueInPounds)
    : value;
  return <span {...props}>{formatCurrency({ value: parsedValue })}</span>;
}

Currency.propTypes = {
  value: PropTypes.number,
  valueInPounds: PropTypes.number,
};

export default Currency;
